import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import Input from "Components/UI/Input";
import { Controller } from "react-hook-form";
import Select from "react-select";
import { useGetEmployeeQuery } from "AppQuries/employee/employee_list";
import { useGetAllDepartmentQuery } from "AppQuries/master/Department/get-all-departments";
import { useGetAdditionsQuery } from "AppQuries/payroll/addition/get-all-additions";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import PropTypes from "prop-types";
import { set } from "date-fns";
import { useGetDeductionsQuery } from "AppQuries/payroll/deduction/get-all-deduction";
import { useFormattedAllowanceOption, useFormattedDeductionOption, useFormattedProjectOption } from "core/Operations/formattedOption/useFormattedMasterOptions";
import { useFormattedDepartmentOption, useFormattedEmployees } from "core/Operations/formattedOption/useFormattedEmployeeOptions";
const isStatusOption = [
  { id: 1, label: "Yes", value: true },
  { id: 0, label: "No", value: false },
];

const typeOptions = [
  {
    label: "Addition",
    value: 1,
  },
  {
    label: "Deduction",
    value: 0,
  },
];
const EmpAllowanceDeductionForm = ({ mode }) => {
  const userData = useSelector(loggedInUser);
  const [isMount, setIsMount] = useState(false);
  const {
    control,
    register,
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useFormContext();

  // const { data: employees, refetch: getEmployees } =  useGetEmployeeQuery({
  //   companyCode: userData?.companyCode,
  //   locationCode: userData?.locationCode,
  //   departmentCode:
  //     watch("departmentCode") === "" ? 0 : watch("departmentCode") || 0,
  // });
  // const { data: departments } = useGetAllDepartmentQuery({
  //   companyCode: userData?.companyCode,
  //   isTrue: true,
  // });

  // const { data: allowance } = useGetAdditionsQuery({
  //   companyCode: userData?.companyCode,
  // });

  // const { data: deductions } = useGetDeductionsQuery({
  //   companyCode: userData?.companyCode,
  // });

  const projectOptions = useFormattedProjectOption({
    companyCode: userData?.companyCode,
    locationCode: userData?.locationCode,
  });

  const employeeOptions = useFormattedEmployees({
    companyCode: userData?.companyCode,
    locationCode: userData?.locationCode,
    departmentCode:
      watch("departmentCode") === "" ? 0 : watch("departmentCode") || 0,
  });

  // Array.isArray(employees)
  //   ? employees
  //       .filter((d) => d.isActive)
  //       .map((o) => ({
  //         id: o.employeeCode,
  //         label: `${o.uniqueId}-${o.fullName}`,
  //         value: o.employeeCode,
  //       }))
  //   : [];

  const departmentOptions = useFormattedDepartmentOption(userData?.companyCode);
  // Array.isArray(departments?.data)
  //   ? departments?.data
  //       .filter((d) => d.isActive)
  //       .map((o) => ({
  //         id: o.code,
  //         label: o.description,
  //         value: o.code,
  //       }))
  //   : [];

  const allowanceOptions = useFormattedAllowanceOption(userData?.companyCode);
  // Array.isArray(allowance?.data)
  //   ? allowance?.data
  //       .filter((d) => d.isActive)
  //       .map((o) => ({
  //         id: o.code,
  //         label: o.description,
  //         value: o.code,
  //       }))
  //   : [];

  const deductionOptions = useFormattedDeductionOption(userData?.companyCode);
  // Array.isArray(deductions?.data)
  //   ? deductions?.data
  //       .filter((d) => d.isActive)
  //       .map((o) => ({
  //         id: o.code,
  //         label: o.description,
  //         value: o.code,
  //       }))
  //   : [];

  // useEffect(() => {
  //   if (isMount) {
  //     getEmployees();
  //   }
  //   setIsMount(true);
  // }, [watch("departmentCode")]);
  console.log(watch());

  return (
    <div className="form-row row">
      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="departmentCode"
          type="commonSelect"
          placeholder=""
          className={`form-control select ${
            errors.departmentCode ? "is-invalid" : ""
          }`}
          label="Department"
          labelClassName="form-label"
          optionData={departmentOptions}
          required={true}
          requiredMessage="Department is required"
          onSelect={(e) => {
            console.log("departmentCode", e);
            setValue("departmentCode", e);
          }}
          disabled={mode === "E" ? true : false}
          isClearable={true}
          onClear={() => {
            setValue("departmentCode", 0);
          }}
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        {mode === "E" ? (
          <Input
            name="employeeCode"
            type="commonSelect"
            placeholder=""
            className={`form-control select ${
              errors.employeeCode ? "is-invalid" : ""
            }`}
            label="Employee"
            labelClassName="form-label"
            optionData={employeeOptions}
            required={true}
            requiredMessage="Employee is required"
            disabled={true}
            style={{ width: "100%", height: "auto" }}
            defaultValue={{ value: watch("employeeCode") }}
          />
        ) : (
          <Input
            name="employeeCode"
            type="commonSelect"
            placeholder=""
            className={`form-control select ${
              errors.employeeCode ? "is-invalid" : ""
            }`}
            label="Employee"
            labelClassName="form-label"
            optionData={employeeOptions}
            required={true}
            requiredMessage="Employee is required"
            //   labelInValue={true}

            mode={"multiple"}
            showSearch={true}
            allowClear={true}
            onChange={(val) => setValue("employeeCode", val)}
            onClear={() => {
              setValue("employeeCode", []);
            }}
            style={{ width: "100%", height: "auto" }}
          />
        )}
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="projectCode"
          type="commonSelect"
          placeholder=""
          className={`form-control select ${
            errors.projectCode ? "is-invalid" : ""
          }`}
          label="Project"
          labelClassName="form-label"
          optionData={projectOptions?.map((o) => ({
            label: o.label,
            value: o.value?.toString(),
          }))}
          required={false}
          requiredMessage="Project is required"
          onChange={(e) => {
            setValue("projectCode", e);
          }}
          defaultValue={watch("projectCode")}
          disabled={mode === "E" ? true : false}
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <div className="form-group">
          <Input
            name="type"
            type="commonSelect"
            placeholder=""
            className={`form-control select ${
              errors.employeeCode ? "is-invalid" : ""
            }`}
            label="Type"
            labelClassName="form-label"
            optionData={typeOptions}
            required={true}
            requiredMessage="Type is required"
            onChange={(e) => {
              setValue("type", e);
            }}
            defaultValue={watch("type")}
            disabled={mode === "E" ? true : false}
          />
        </div>
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="code"
          type="commonSelect"
          placeholder=""
          className={`form-control select ${errors.code ? "is-invalid" : ""}`}
          label={`${
            watch("type") === 1
              ? "Allowance"
              : watch("type") === 0
              ? "Deduction"
              : ""
          } Name`}
          labelClassName="form-label"
          optionData={
            watch("type") === 1
              ? allowanceOptions
              : watch("type") === 0
              ? deductionOptions
              : []
          }
          required={true}
          requiredMessage=""
          labelInValue
          onSelect={(e) => {
            console.log(e);
            setValue("code", e.value);
            setValue("description", e.label);
            trigger("code");
            trigger("description");
          }}
          value={
            watch("type") === 1
              ? allowanceOptions.find(
                  (option) => option.value === watch("code")
                )
              : watch("type") === 0
              ? deductionOptions.find(
                  (option) => option.value === watch("code")
                )
              : ""
          }
          disabled={mode === "E" ? true : false}
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="amount"
          type="text"
          placeholder="Amount"
          className={`form-control ${errors.amount ? "is-invalid" : ""}`}
          label="Amount"
          labelClassName="form-label"
          required={true}
          requiredMessage="Amount is required"
          defaultValue=""
        />
      </div>

      {/* <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="haveCPF"
          type="commonSelect"
          placeholder=""
          className={`form-control select ${
            errors.haveCPF ? "is-invalid" : ""
          }`}
          label="Have CPF"
          labelClassName="form-label"
          optionData={isStatusOption}
          required={true}
          requiredMessage="Have CPF is required"
          onChange={(selectedOption) => {
            setValue("haveCPF", selectedOption);
            trigger("haveCPF");
          }}
          defaultValue={watch("haveCPF")}
        />
      </div> */}

      {/* <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="isTaxPayable"
          type="commonSelect"
          placeholder=""
          className={`form-control select ${
            errors.isTaxPayable ? "is-invalid" : ""
          }`}
          label="Tax Payable"
          labelClassName="form-label"
          optionData={isStatusOption}
          required={true}
          requiredMessage="Tax Payable is required"
          onChange={(selectedOption) => {
            setValue("isTaxPayable", selectedOption);
            trigger("isTaxPayable");
          }}
          defaultValue={watch("isTaxPayable")}
        />
      </div> */}

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="effectiveDateFrom"
          type="date"
          placeholder=""
          className={`form-control ${
            errors.effectiveDateFrom ? "is-invalid" : ""
          }`}
          label="Effective From"
          labelClassName="form-label"
          required={false}
          requiredMessage="Effective From is required"
          dateFormat="YYYY-MM-DD"
          // disabledDate={(current) => {
          //   return current < dayjs().subtract(1, "day").endOf("day");
          // }}
          defaultValue={watch("effectiveDateFrom") || null}
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="effectiveDateTo"
          type="date"
          placeholder=""
          className={`form-control ${
            errors.effectiveDateTo ? "is-invalid" : ""
          }`}
          label="Effective To"
          labelClassName="form-label"
          required={false}
          requiredMessage="Effective To is required"
          dateFormat="YYYY-MM-DD"
          // disabledDate={(current) => {
          //   const effectiveDateFrom = dayjs(watch("effectiveDateFrom"));
          //   return (
          //     current < dayjs().subtract(1, "day").endOf("day") ||
          //     current < effectiveDateFrom
          //   );
          // }}
          defaultValue={watch("effectiveDateTo") || null}
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="isTemporary"
          type="commonSelect"
          placeholder=""
          className={`form-control select ${
            errors.isTemporary ? "is-invalid" : ""
          }`}
          label="Is Temporary?"
          labelClassName="form-label"
          optionData={isStatusOption}
          required={true}
          requiredMessage="isTemporary is required"
          onSelect={(selectedOption) => {
            console.log(selectedOption);
            if (selectedOption === true) {
              setValue("effectiveDateFrom", watch("effectiveDateFrom") || "");
              setValue("effectiveDateTo", watch("effectiveDateTo") || "");
            } else {
              setValue("effectiveDateFrom", null);
              setValue("effectiveDateTo", null);
            }
            setValue("isTemporary", selectedOption);
            trigger("isTemporary");
          }}
          defaultValue={watch("isTemporary")}
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="isActive"
          type="commonSelect"
          placeholder=""
          className={`form-control select ${
            errors.isActive ? "is-invalid" : ""
          }`}
          label="Status"
          labelClassName="form-label"
          optionData={isStatusOption}
          required={true}
          requiredMessage="Status is required"
          onChange={(selectedOption) => {
            setValue("isActive", selectedOption);
            trigger("isActive");
          }}
          defaultValue={watch("isActive")}
        />
      </div>
    </div>
  );
};

EmpAllowanceDeductionForm.propTypes = {
  mode: PropTypes.string.isRequired,
};

export default EmpAllowanceDeductionForm;
